import { ChangeDetectorRef, Component } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GetFieldPipe } from '../../../pipes/get-field.pipe';
import { TextCellComponent } from '../text-cell/text-cell.component';

@Component({
    standalone: false,
    selector: 'digihaven-icon-cell',
    templateUrl: './icon-cell.component.html'
})
export class IconCellComponent extends TextCellComponent {
    iconName$: Observable<string>;

    constructor(fieldPipe: GetFieldPipe, cd: ChangeDetectorRef) {
        super(fieldPipe, cd);

        this.iconName$ = this.setupClassStream();
    }

    private setupClassStream(): Observable<string> {
        return this.data$.pipe(
            map(apiFragment => {
                return apiFragment.metadata.Dynamic.AnalogCluster ? 'file-cluster' : 'file';
            })
        );
    }
}
